import { render, staticRenderFns } from "./BidDashboardStats.vue?vue&type=template&id=27d0d694&scoped=true"
import script from "./BidDashboardStats.vue?vue&type=script&lang=js"
export * from "./BidDashboardStats.vue?vue&type=script&lang=js"
import style0 from "./BidDashboardStats.vue?vue&type=style&index=0&id=27d0d694&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d0d694",
  null
  
)

export default component.exports